module.exports = __webpack_public_path__ + "img/IMG_3579.2f1d57b9.png";